<template>
  <v-row justify="center">
    <v-dialog scrollable max-width="800px" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <v-btn color="info" v-on="on" >Asignar</v-btn>
      </template>
      <v-card max-width="800" height="80%">
        <v-card-title>
          <h4>Asignar autor</h4>
        </v-card-title>
        <v-card-text>
          <v-container
            id="scroll-target"
            class="overflow-y-auto"
            style="max-height: 600px"
          >
            <v-text-field
              type="text"
              label="Nombres o cedula"
              v-model="busqueda"
              autofocus
            />
            <v-btn @click="buscar">Buscar</v-btn>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Cedula</th>
                    <th class="text-left">Nombres</th>
                    <th class="text-left">Celular</th>
                    <th class="text-right">Monto</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in autores" :key="detalle.id">
                    <td>{{ detalle.cedula }}</td>
                    <td>{{ detalle.nombres + " " + detalle.apellidos }}</td>
                    <td>{{ detalle.celularBeneficiario }}</td>
                    <td class="text-right">
                      {{ detalle.monto | numberFormat }}
                    </td>
                    <td>
                      <v-btn
                        small
                        :loading="detalle.loading"
                        :disabled="loading && !detalle.loading"
                        color="info"
                        @click="confirmar(detalle)"
                        >Seleccionar</v-btn
                      >
                    </td>
                    <!-- <td><v-btn small color="primary" v-if="pago.estado=='Validado'">Anular</v-btn></td> -->
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" @click="volver">Volver</v-btn>
          <div v-if="errorMessage" style="color: red"> {{ errorMessage }}</div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";
import numeral from "numeral";

export default Vue.extend({
  props: ['solicitud_id'],
  data() {
    return {
      loading: false,
      showDialog: false,
      errorMessage: null,
      descripcion: "",
      busqueda: "",
      buscarTimer: null,
      autores: [],
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      },
      validForm: false
    };
  },
  mounted() {},
  methods: {
    buscar() {
      if (!this.busqueda) return;
      axios
        .get("/autor?nombreCompleto="+this.busqueda+"&isSocio=true")
        .then(response => {
          this.loading = false;
          this.autores = response.data.map(obj => ({...obj, loading: false }));        
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.autores = this.autores.data.map(obj => ({...obj, loading: false }));        
          this.errorMessage = "Error en la consulta";
        });
    },
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    confirmar(autor) {
      this.loading=true;
      autor.loading = true;
      console.log(autor)
      // this.busqueda = "";
      // this.showDialog = false;
      axios
        .post(`/solicitudUsuarioWeb/${this.solicitud_id}/setAutor?autor_id=${autor.id}`)
        .then(response => {
          this.loading = false;
          this.showDialog = false;
          console.log(response);
          this.$emit("asignado", { autor: autor, solicitud_id: this.solicitud_id });
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.errorMessage = err.response.data;
        });

    },
    volver() {
      this.busqueda = "";
      this.showDialog = false;
    }
  },
  filters: {
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    }
  }
});
</script>
